// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.supplier-fleet-select[data-v-3e3140c0] {\n  min-width: 170px;\n}\n", ""]);
// Exports
module.exports = exports;
